import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

const clientEnv = (name: string, defaultValue: string | undefined) => {
  if (process.env.NODE_ENV === "production" && !process.env.TEST_ENV) {
    return `${name}`;
  }
  return defaultValue;
};

export const env = createEnv({
  skipValidation: Boolean(process.env.SKIP_ENV_VALIDATION),
  server: {
    ORY_SESSION_COOKIE: z.string().min(1, "Required."),
    BILLING_GRPC_URL: z.string().min(1),
    COMPUTE_GRPC_URL: z.string().min(1),
    CSP_GRPC_URL: z.string().min(1),
    IDENTITY_GRPC_URL: z.string().min(1),
    IDENTITY_PUBLIC_GRPC_URL: z.string().min(1),
    RUNNER_GRPC_URL: z.string().min(1),
    RUNNER_PUBLIC_GRPC_URL: z.string().min(1),
    WORKSPACE_GRPC_URL: z.string().min(1),
    AUDIT_GRPC_URL: z.string().optional(),
    GITHUB_PROXY_URL: z.string().min(1),
    RUNNER_STATE_SECRET_KEY: z.string().min(1),
    GOOGLE_ANALYTICS_ID: z.string().optional(),
    KRATOS_WEBHOOK_TOKEN: z.string().min(1, "Required"),
    NOTIFICATION_GRPC_URL: z.string().min(1, "Required"),
    TRACING_ENVIRONMENT: z.string().optional().default("local"),
    TEMPO_ENDPOINT: z.string().optional(),
    TEMPO_USERNAME: z.string().optional(),
    TEMPO_PASSWORD: z.string().optional(),
    NOTIFICATION_SENDER_EMAIL: z.string().optional().default("no-reply@tenki.cloud"),
    GOOGLE_ADS_ID: z.string().optional(),
    GOOGLE_TAG_MANAGER_ID: z.string().optional(),
  },
  client: {
    NEXT_PUBLIC_ASSET_CDN: z.string().optional(),
    NEXT_PUBLIC_RUNNER_PREFIX: z.string().min(1).default("tenki-local"),
    NEXT_PUBLIC_RUNNER_PREFIX_EXCLUDE: z
      .string()
      .optional()
      .transform((val) => (!val || val.startsWith("$NEXT_PUBLIC") ? [] : val.split(",").map((s) => s.trim()))),
    NEXT_PUBLIC_APP_UI: z.string().min(1),
    NEXT_PUBLIC_DOCS_UI: z.string().min(1),
    NEXT_PUBLIC_GITHUB_APP_NAME: z.string().optional(),
    NEXT_PUBLIC_POSTHOG_KEY: z.string().optional(),
    NEXT_PUBLIC_COOKIE_DOMAIN: z.string().min(1),
    NEXT_PUBLIC_POSTHOG_HOST: z.string().optional().default("/posthog"),
    NEXT_PUBLIC_DOCUMENTATION_LINK: z.string().min(1, "Required"),
    NEXT_PUBLIC_UNLEASH_URL: z.string().optional(),
    NEXT_PUBLIC_UNLEASH_ENVIRONMENT: z.string().optional(),
    NEXT_PUBLIC_UNLEASH_FRONTEND_API_KEY: z.string().optional(),
    NEXT_PUBLIC_UNLEASH_CLIENT_API_KEY: z.string().optional(),
  },
  shared: {
    NODE_ENV: z.enum(["development", "production"]),
  },
  // runtime env in nextjs is strict by default
  // need to destructure process.env manually
  experimental__runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_ASSET_CDN: clientEnv("cdn.tenki.cloud", process.env.NEXT_PUBLIC_ASSET_CDN),
    NEXT_PUBLIC_RUNNER_PREFIX: clientEnv("tenki", process.env.NEXT_PUBLIC_RUNNER_PREFIX),
    NEXT_PUBLIC_RUNNER_PREFIX_EXCLUDE: clientEnv(
      "$NEXT_PUBLIC_RUNNER_PREFIX_EXCLUDE",
      process.env.NEXT_PUBLIC_RUNNER_PREFIX_EXCLUDE,
    ),
    NEXT_PUBLIC_APP_UI: clientEnv("https://app.tenki.cloud", process.env.NEXT_PUBLIC_APP_UI),
    NEXT_PUBLIC_DOCS_UI: clientEnv("https://www.tenki.cloud/docs", process.env.NEXT_PUBLIC_DOCS_UI),
    NEXT_PUBLIC_GITHUB_APP_NAME: clientEnv("tenki-cloud", process.env.NEXT_PUBLIC_GITHUB_APP_NAME),
    NEXT_PUBLIC_POSTHOG_KEY: clientEnv("phc_LJHzH2qCgUGAbJLGiceRgk9hYktZP6G6eTvaU1OpR1r", process.env.NEXT_PUBLIC_POSTHOG_KEY),
    NEXT_PUBLIC_POSTHOG_HOST: clientEnv("https://us.i.posthog.com", process.env.NEXT_PUBLIC_POSTHOG_HOST),
    NEXT_PUBLIC_COOKIE_DOMAIN: clientEnv(".tenki.cloud", process.env.NEXT_PUBLIC_COOKIE_DOMAIN),
    NEXT_PUBLIC_DOCUMENTATION_LINK: clientEnv(
      "https://www.tenki.cloud/docs",
      process.env.NEXT_PUBLIC_DOCUMENTATION_LINK,
    ),
    NEXT_PUBLIC_UNLEASH_URL: clientEnv("https://us.app.unleash-hosted.com/usbb1004", process.env.NEXT_PUBLIC_UNLEASH_URL),
    NEXT_PUBLIC_UNLEASH_ENVIRONMENT: clientEnv(
      "production",
      process.env.NEXT_PUBLIC_UNLEASH_ENVIRONMENT,
    ),
    NEXT_PUBLIC_UNLEASH_FRONTEND_API_KEY: clientEnv(
      "tenki:production.fdb155c3aa9b2b78f13b5a2e2fc8183ecf79eff22c4113f381e132dd",
      process.env.NEXT_PUBLIC_UNLEASH_FRONTEND_API_KEY,
    ),
    NEXT_PUBLIC_UNLEASH_CLIENT_API_KEY: clientEnv(
      "tenki:production.613baf35b99c424e99cddb6b2eceb97003c60f60f902c504a48db703",
      process.env.NEXT_PUBLIC_UNLEASH_CLIENT_API_KEY,
    ),
  },
});
